enum ValidationOptionsEnum {
  Regex = "regex",
  Email = "email",
  List = "list",
  Phone = "phone",
  Length = "length",
  Range = "range",
  Decimal = "decimal",
}

export default ValidationOptionsEnum;
